export default __webpack_public_path__ + "static/media/hackathonDark.0bfc4743.svg";